import React from 'react'
import { connect } from 'react-redux'
import { change as changeFieldValue } from 'redux-form';
import Titulo from '../comum/Titulo';
import {
    getFinanceiroAgencia,
    getFinanceiroCaixa,
    getPerfisEmpresa,
    hasPerfil,
    PERFIL_ADMIN,
} from '../../security/securityContext';
import Autorizacao from '../../security/Autorizacao';
import determinarPaginaAtual from '../../actions/venda/determinarPaginaAtualVenda'
import limparFiltroEncomenda from '../../actions/encomenda/limparFiltroEncomenda'
import ModalCadastroValorPesoEncomenda from './ModalCadastroValorPesoEncomenda';
import buscarEncomendasEmpresa from '../../actions/encomenda/buscarEncomendasEmpresa';
import { alterouEmpresa } from '../../actions/empresa/alterarEmpresaSelecionada';
import Encomenda from './Encomenda';
import ModalConfirmacaoCancelamentoEncomenda from './ModalConfirmacaoCancelamentoEncomenda';
import CampoSelecionarEmpresa from '../layout/CampoSelecionarEmpresa';
import ModalAlterarFormaPagamento from '../pedido/ModalAlterarFormaPagamento';
import ModalInformarComprovante from '../pedido/ModalInformarComprovante';
import ModalImagensEncomenda from './ModalImagensEncomenda';
import CabecalhoRodapeTabela from '../comum/CabecalhoRodapeTabela';
import PaginacaoEncomenda from './PaginacaoEncomenda';
import BotoesPaginacaoEncomenda from './BotoesPaginacaoEncomenda';
import { alterouFiltro, alterouPagina } from '../../util/filtros';
import determinarPaginaAtualEncomenda from '../../actions/encomenda/determinarPaginaAtualEncomenda';
import ModalHistoricoEncomenda from './ModalHistoricoEncomenda';
import PainelFiltragem from './PainelFiltrosEncomendas';
import { gerarHashForString } from '../../util/stringUtil';
import ModalInformarEntregaEncomenda from './ModalInformarEntregaEncomenda';
import ModalTransmitirCte from './ModalTransmitirCte';
import buscarOpcoesFiltrosEmissaoesCte from '../../actions/cteos/buscarOpcoesFiltrosEmissaoesCte';
import buscarSeUsuarioVendeEncomendaComCte from '../../actions/usuario/buscarSeUsuarioVendeEncomendaComCte';

export const CabecalhoTabela = () => (
    <div className="vx-gp-table-header vx-gp-table-header--encomenda">
        <div></div>
        <div>Nº Pedido</div>
        <div>Vendedor</div>
        <div>Descrição</div>
        <div>Remetente</div>
        <div>Destinatário</div>
        <div>Situação Ct-e</div>
        <div>Status evento Ct-e</div>
        <div>Data emissão</div>
        <div>Status pedido</div>
        <div>Valor</div>
        <div>Ações</div>
    </div>
);

export class PainelGerenciarEncomendas extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            arquivos: [],
            imagensInformarEntrega: [],
            historicos: [],
            idPedido: null
        };
    }

    UNSAFE_componentWillMount() {
        this.props.determinarPaginaAtualEncomenda(1)
        this.props.limparFiltroEncomenda();
    }

    componentDidMount() {
        if (this.props.empresaSelecionada.id) {
            this.buscarEncomendas()
            this.props.buscarOpcoesFiltrosEmissaoesCte(this.props.empresaSelecionada.id).catch(() => {});
            this.props.buscarSeUsuarioVendeEncomendaComCte(this.props.empresaSelecionada.id);
        }
    }

    buscarEncomendas() {
        this.props.buscarEncomendasEmpresa(this.props.empresaSelecionada.id, this.props.paginaAtual, this.props.registrosPorPagina, this.props.filtrosAdicionados);
    }

    componentDidUpdate(prevProps) {
        if (alterouEmpresa(this.props, prevProps) || alterouFiltro(this.props, prevProps) || alterouPagina(this.props, prevProps)) {
            this.buscarEncomendas()
            if (!alterouPagina(this.props, prevProps)) {
                this.props.determinarPaginaAtualEncomenda(1)
            }
        }
    }

    preencherModalImagensEncomenda(imagens) {
        if (imagens && imagens.length > 0) {
            this.setState({ arquivos: this.mapearObjetoImagem(imagens) })
        }
    }

    preencherModalInformarEntregaEncomenda(imagensInformarEntrega) {
        if (imagensInformarEntrega && imagensInformarEntrega.length > 0) {
            this.setState({ imagensInformarEntrega: this.mapearObjetoImagem(imagensInformarEntrega) })
        }
    }

    mapearObjetoImagem(imagens) {
        return imagens.map(it => ({
            hash: gerarHashForString(`${it.nome}`),
            ...it
        }));
    }

    removerImagemInformarEntrega(arquivo) {
        this.setState({ imagensInformarEntrega: this.state.imagensInformarEntrega.filter(it => it.hash != arquivo.hash) });
    }

    adicionarImagensInformarEntrega(arquivos) {
        this.setState({ imagensInformarEntrega: arquivos });
    }

    limparImagensInformarEntrega() {
        this.setState({ imagensInformarEntrega: [] });
    }

    removerImagem(arquivo) {
        this.setState({ arquivos: this.state.arquivos.filter(it => it.hash != arquivo.hash) });
    }

    adicionarImagens(arquivos) {
        this.setState({ arquivos });
    }

    limparImagens() {
        this.setState({ arquivos: [] });
    }

    selecionarHistoricos(historicos, idPedido) {
        this.setState({ historicos, idPedido });
    }

    exibirEncomendas() {
        return this.props.encomendas.map((encomenda, index) => (
            <Encomenda key={index} encomenda={encomenda}
                selecionarHistoricos={this.selecionarHistoricos.bind(this)}
                preencherModalImagensEncomenda={this.preencherModalImagensEncomenda.bind(this)}
                preencherModalInformarEntregaEncomenda={this.preencherModalInformarEntregaEncomenda.bind(this)}
                indice={index} />
        ))
    }

    exibirTabelaEncomendas() {
        if (this.props.encomendas && this.props.encomendas.length) {
            return (
                <div className="vx-list-container" style={{ marginTop: 16 }}>
                    <CabecalhoRodapeTabela OpcoesPaginacao={PaginacaoEncomenda}
                        BotoesPaginacao={BotoesPaginacaoEncomenda}
                        encomendas={this.props.encomendas}
                        empresaSelecionada={this.props.empresaSelecionada}>
                        <CabecalhoTabela />
                        {this.exibirEncomendas()}
                    </CabecalhoRodapeTabela>
                </div>
            )
        }
        return (
            <div className="vx-gp-empty">
                <span className="material-icons vx-gp-empty-icon">inventory</span>
                <p className="vx-gp-empty-text">Nenhuma encomenda cadastrada</p>
            </div>
        );
    }

    render() {
        if (this.props.empresaSelecionada.habilitadoEncomenda || hasPerfil(PERFIL_ADMIN)) {
            return (
                <Autorizacao perfisPermitidos={[PERFIL_ADMIN, ...getPerfisEmpresa(this.props.empresaSelecionada.id),
                    getFinanceiroAgencia(this.props.empresaSelecionada.id),
                    getFinanceiroCaixa(this.props.empresaSelecionada.id)]}
                    empresaSelecionada={this.props.empresaSelecionada}>
                    <div>
                        <div className="row internas">
                            <Titulo texto="Gerenciar encomendas" urlRetorno="/menu-encomendas" />
                            <Autorizacao perfisPermitidos={[PERFIL_ADMIN]}>
                                <div className='col-12'>
                                    <ul className="nav navbar-nav ml-auto opcoes-menu menu-desktop">
                                        <li className="nav-item dropdown nome-empresa">
                                            <div className='col-md-6'>
                                                <CampoSelecionarEmpresa />
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </Autorizacao>
                            <div className="col-12" style={{ marginBottom: 12 }}>
                                <PainelFiltragem />
                            </div>
                            <div className='col-12'>
                                {this.exibirTabelaEncomendas()}
                            </div>
                        </div>
                    </div>
                    <ModalCadastroValorPesoEncomenda />
                    <ModalConfirmacaoCancelamentoEncomenda buscarPedidos={this.buscarEncomendas.bind(this)} />
                    <ModalAlterarFormaPagamento buscarPedidos={this.buscarEncomendas.bind(this)} />
                    <ModalInformarComprovante buscarPedidos={this.buscarEncomendas.bind(this)} />
                    <ModalImagensEncomenda buscarEncomendas={this.buscarEncomendas.bind(this)}
                        arquivos={this.state.arquivos}
                        removerImagem={this.removerImagem.bind(this)}
                        adicionarImagens={this.adicionarImagens.bind(this)}
                        limparImagens={this.limparImagens.bind(this)} />
                    <ModalInformarEntregaEncomenda buscarEncomendas={this.buscarEncomendas.bind(this)}
                        arquivos={this.state.imagensInformarEntrega}
                        removerImagem={this.removerImagemInformarEntrega.bind(this)}
                        adicionarImagens={this.adicionarImagensInformarEntrega.bind(this)}
                        limparImagens={this.limparImagensInformarEntrega.bind(this)} />
                    <ModalHistoricoEncomenda historicos={this.state.historicos} idPedido={this.state.idPedido} />
                    <ModalTransmitirCte buscarPedidos={this.buscarEncomendas.bind(this)} />
                </Autorizacao>
            )
        }
        return '';
    }
}


export const mapStateToProps = state => ({
    encomendas: state.encomendas.encomendas,
    empresaSelecionada: state.empresaSelecionada,
    changeFieldValue,
    filtrosAdicionados: state.filtrosAdicionadosEncomenda,
    paginaAtual: state.paginaAtualEncomenda,
    registrosPorPagina: state.registrosPorPaginaEncomenda
});


export default connect(mapStateToProps, {
    determinarPaginaAtual,
    limparFiltroEncomenda,
    buscarEncomendasEmpresa,
    determinarPaginaAtualEncomenda,
    buscarOpcoesFiltrosEmissaoesCte,
    buscarSeUsuarioVendeEncomendaComCte
})(PainelGerenciarEncomendas)
